var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.3791C5.00468 6.66563 7.5648 3.65473 11.0517 3.09154C14.9009 2.4698 18.5757 5.08085 19.2419 8.9301C19.6277 11.1589 19.088 13.1575 17.6279 14.8828C15.9705 16.8417 14.2903 18.7807 12.6189 20.7273C12.3051 21.0926 12.0592 21.0914 11.7413 20.7208C10.0506 18.752 8.3528 16.7896 6.67494 14.8108C5.55441 13.4895 5.02225 11.9393 5 10.3791ZM12.1804 19.8561C12.2612 19.7642 12.3238 19.6951 12.3847 19.6243C13.8992 17.8598 15.4202 16.1005 16.9265 14.3296C18.1712 12.866 18.6682 11.1635 18.3901 9.26497C17.8785 5.77577 14.6234 3.40475 11.1336 4.01067C8.76378 4.42224 7.10465 5.80738 6.28855 8.0701C5.46952 10.3416 5.89396 12.4539 7.43132 14.3191C8.19415 15.244 8.99151 16.1409 9.77249 17.0507C10.5675 17.9769 11.3625 18.9036 12.181 19.8573L12.1804 19.8561Z",
    fill: "#4B4B4B",
    stroke: "#4B4B4B",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1686 7.05133C13.8682 7.02733 15.2949 8.43003 15.3253 10.1541C15.3558 11.8847 13.9554 13.326 12.2178 13.3518C10.4914 13.3776 9.05938 11.9696 9.03889 10.2262C9.0184 8.49502 10.417 7.07592 12.1681 7.05133H12.1686ZM12.1657 12.4455C13.4256 12.4473 14.4196 11.4556 14.4214 10.1951C14.4232 8.954 13.4226 7.95642 12.1762 7.95642C10.9457 7.95642 9.94807 8.95166 9.9428 10.1852C9.93695 11.4345 10.9299 12.4438 12.1657 12.4455V12.4455Z",
    fill: "#4B4B4B",
    stroke: "#4B4B4B",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.605aa6a4024a4ff90d08d687affdb2b8.svg";
export { ForwardRef as ReactComponent };